import React, {useState,createContext} from 'react';
import type {} from '@mui/x-date-pickers/themeAugmentation';
import type {} from '@mui/x-charts/themeAugmentation';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';

import AppNavbar from './components/AppNavbar';
import OcpfUsTraffic from './components/OcpfUsTraffic';
import SideMenu from './components/SideMenu';
import TopBar from '../../components/nav/TopBar';
import DashboardContent from './components/DashboardContent';
import SqlServerStatus from './components/SqlServerStatus';
import OcpfUsSearchEngine from './components/OcpfUsSearchEngine';
import StaffManagement from './components/StaffManagement';
import EmailServer from './components/EmailServer';

export interface SectionCommunication {
    activeSection: string;
    setActiveSection: (newSection: string) => void;
}

export const ActiveSectionContext = createContext<SectionCommunication>({
    activeSection: 'website',
    setActiveSection: () => { }
});

const ItDashboardApp2 = (): JSX.Element => {

    //set up browser title
    const pageTitle = 'Extranet - IT Dashboard';
    document.title = pageTitle;

    const applicationName = 'IT Dashboard';

    //initial state setup
    const [activeSection, setActiveSection] = useState('website');

    const renderContent = () => {
        switch (activeSection) {
            case 'dashboard':
                return <DashboardContent />;
            case 'databases':
                return <SqlServerStatus />;
            case 'emails':
                return <EmailServer />;
            case 'website':
                return <OcpfUsTraffic />;
            case 'searches':
                return <OcpfUsSearchEngine />;
            case 'staff':
                return <StaffManagement />;
            default:
                return <DashboardContent />;
        }
    };

    return (
    <div>
        <ActiveSectionContext.Provider value={{
            activeSection: activeSection,
            setActiveSection: (newSection: string) => {
                setActiveSection(newSection);
                }
            }} >
            <Grid container sx={{ display: 'flex' }}>
              <CssBaseline />
              <TopBar applicationName={applicationName} homepageLink={'/Apps/ItDashboard2'} ></TopBar>
            </Grid>
            <Grid item xs={12} marginBottom={1}>
              <Divider />
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex' }}>
                <SideMenu />
                <AppNavbar />
                {/* Main content */}
                <Box
                    component="main"
                    sx={(theme) => ({
                    flexGrow: 1,
                    overflow: 'auto',
                })}
                >
                <Stack
                    spacing={2}
                    sx={{
                        alignItems: 'center',
                        mx: 3,
                        pb: 5,
                        mt: { xs: 8, md: 0 },
                    }}
                        >
                    {renderContent()}
                </Stack>
                </Box>
            </Grid>
        </ActiveSectionContext.Provider>
    </div>
  );
}

export default ItDashboardApp2
